import React, { useRef } from "react";
import {
  Box,
  Typography,
  Button,
} from "@mui/material";
import PrintIcon from "@mui/icons-material/Print";
import { useReactToPrint } from "react-to-print";
import config from "../config/Config";

const Form12BBInstructions = () => {
  const formRef = useRef();

  const handlePrint = useReactToPrint({
    contentRef: formRef,
    pageStyle: `
      @page {
        size: A4;
        margin: 12mm 14mm;
      }
      @media print {
        html, body {
          width: 210mm;
          height: 297mm;
          margin: 0;
          padding: 0;
        }
        .no-print {
          display: none !important;
        }
        * {
          -webkit-print-color-adjust: exact !important;
          print-color-adjust: exact !important;
        }
      }
    `,
  });

  return (
    <Box>
      {/* Print Button - Hidden on print */}
      <Box sx={{ textAlign: "center", mb: 2 }} className="no-print">
        <Button
          variant="contained"
          startIcon={<PrintIcon />}
          onClick={handlePrint}
        >
          Print
        </Button>
      </Box>

      {/* Printable Content */}
      <Box
        ref={formRef}
        sx={{
          backgroundColor: "#fff",
          p: 3,
          fontFamily: '"Times New Roman", Times, serif',
          maxWidth: "210mm",
          mx: "auto",
          fontSize: "13px",
          lineHeight: 1.45,
          color: "#000",
          // border: "1px solid #ccc",
        }}
      >
        {/* Header */}
        <Box
          sx={{
            position: "relative",
            mb: 2.5,
            minHeight: "48px",
          }}
        >
          <Box sx={{ position: "absolute", left: 0, top: 0 }}>
            <img
              src={
                config?.IMAGE_PATH
                  ? config.IMAGE_PATH + "logo512.png"
                  : "/logo512.png"
              }
              alt="HLFPPT Logo"
              height="45"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "/logo512.png";
              }}
            />
          </Box>

          <Typography
            align="center"
            sx={{
              fontSize: "17px",
              fontWeight: "bold",
              textDecoration: "underline",
              pt: 1,
            }}
          >
            Instructions for filling Form 12BB
          </Typography>
        </Box>

        {/* 1. HOUSE RENT ALLOWANCE */}
        <Typography
          sx={{
            fontSize: "14px",
            fontWeight: "bold",
            mb: 1,
          }}
        >
          1. HOUSE RENT ALLOWANCE
        </Typography>

        <Box component="ul" sx={{ pl: 3, m: 0, mb: 2 }}>
          <Typography component="li" sx={{ fontSize: "13px", mb: 0.8 }}>
            Total rent paid to landlord shall be mentioned in amount column.
          </Typography>
          <Typography component="li" sx={{ fontSize: "13px", mb: 0.8 }}>
            In evidence rent receipts shall be submitted (Minimum 4 receipts, 1 for each quarter with revenue stamps). All rent receipts shall be original and no Xerox copy will be accepted.
          </Typography>
          <Typography component="li" sx={{ fontSize: "13px", mb: 0.8 }}>
            Address of the Landlord shall be evidenced by, either{" "}
            <strong>Rent Agreement</strong> or <strong>electricity bill, water bill, landline phone bill</strong> or any other documentary proof evidencing existence of the address claimed on rent by the employee.
          </Typography>
          <Typography component="li" sx={{ fontSize: "13px", mb: 0.8 }}>
            PAN of the landlord is compulsory in case the rent paid exceeds Rs. 1,00,000/- in aggregate.
          </Typography>
          <Typography component="li" sx={{ fontSize: "13px", mb: 0.8 }}>
            <strong>Declaration for non availability of PAN by landlord is no longer valid.</strong> No declaration will be accepted where the aggregate rent claimed exceeds Rs. 1,00,000/- and no PAN of Landlord is provided.
          </Typography>
        </Box>

        {/* 2. LEAVE TRAVEL CONCESSIONS */}
        <Typography
          sx={{
            fontSize: "14px",
            fontWeight: "bold",
            mb: 1,
          }}
        >
          2. LEAVE TRAVEL CONCESSIONS:
        </Typography>
        <Typography sx={{ fontSize: "13px", mb: 2, pl: 1 }}>
          Submit original bills in case LTA claimed (if applicable).
        </Typography>

        {/* 3. DEDUCTION OF INTEREST ON BORROWING */}
        <Typography
          sx={{
            fontSize: "14px",
            fontWeight: "bold",
            mb: 1,
          }}
        >
          3. DEDUCTION OF INTEREST ON BORROWING:
        </Typography>

        <Box component="ul" sx={{ pl: 3, m: 0, mb: 2 }}>
          <Typography component="li" sx={{ fontSize: "13px", mb: 0.8 }}>
            Interest paid / payable refers to Housing Loan interest under section 24.
          </Typography>
          <Typography component="li" sx={{ fontSize: "13px", mb: 0.8 }}>
            Name of the lender/bank/financial institution is to be mentioned and interest certificate from lender/bank/financial institution is to be submitted as proof.
          </Typography>
          <Typography component="li" sx={{ fontSize: "13px", mb: 0.8 }}>
            PAN of the bank/financial institution/lender is to be mentioned and interest certificate will suffice as evidence.
          </Typography>
        </Box>

        {/* 4. Deduction under Chapter VI-A */}
        <Typography
          sx={{
            fontSize: "14px",
            fontWeight: "bold",
            mb: 1,
          }}
        >
          4. Deduction under Chapter VI-A
        </Typography>

        <Box component="ul" sx={{ pl: 3, m: 0 }}>
          <Typography component="li" sx={{ fontSize: "13px", mb: 0.8 }}>
            All the applicable investments shall be mentioned by employee, which he intends to make during the financial year and shall mention the documents he will be providing to substantiate the same at the year end.
          </Typography>
          <Typography component="li" sx={{ fontSize: "13px", mb: 0.8 }}>
            Investments under Life Insurance, PPF, NSC, NPS, Mutual Funds, ELSS, Tuition fees, EPF, housing loan principal, Tax saving FD, etc shall be mentioned under{" "}
            <strong>4(A)(i)</strong>.
          </Typography>
          <Typography component="li" sx={{ fontSize: "13px", mb: 0.8 }}>
            Policy for medical insurance, education loan, donation, etc shall be mentioned under{" "}
            <strong>4(b)</strong>.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default Form12BBInstructions;